import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { LinkPageComponent } from "./link-page.component";

@NgModule({
  declarations: [LinkPageComponent],
  imports: [CommonModule, TranslateModule, LucideAngularModule],
})
export class LinkPageModule {}
